import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import { Input as StyledInput } from './styles'
import { InputData, Html } from './type'

interface Props extends FieldRenderProps<string, HTMLInputElement> {
  id: string
  data: InputData
  html: Html
}


const Hidden: React.FC<Props> = ({
  id,
  input,
  html,
}) => (
  <StyledInput
    id={id}
    {...input}
    {...html}
    hidden
  />
)

export default Hidden
